import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'signin-sign_in_password_submit-click';

/**
 * This will be used for record password submission on sign-in flow.

There will be a parameter or two.
["INCORRECT"] -> means submitted password is not correct
["CORRECT"]
["CORRECT", "MFA_PHONE"] -> For the MFA flow, after putting the code, will be asked to put the number again.
["CORRECT", "MFA_EMAIL"]
There will also be incorrect combination with MFA
 */
export function trackSigninSignInPasswordSubmitClick(
  Correctness: string,
  MFA2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { Correctness, MFA2 },
  });
}
